import { useMutation } from '@apollo/client'
import mutationGraphQL from '@src/graphql/mutation/updatePlanetName'
import * as R from 'ramda'
import { useCallback, useState } from 'react'

export const deserializeResponse = R.pathOr(false, ['data', 'updatePlanetName'])

const useUpdatePlanetName = (): Hook => {
  const [updatePlanetName, { loading }] = useMutation(mutationGraphQL)

  const [data, setData] = useState<Response>(false)

  const mutate = useCallback(
    async (request: Request): Promise<Response> => {
      const response = await updatePlanetName({
        variables: {
          input: request
        }
      })

      const result = deserializeResponse(response)

      setData(result)

      return result
    },
    [updatePlanetName]
  )

  return {
    mutate,
    data,
    loading
  }
}

type Request = {
  planetID: string
  name: string
}

type Response = boolean

type Hook = {
  mutate: (request: Request) => Promise<Response>
  data: Response
  loading: boolean
}

export default useUpdatePlanetName
